module.exports = __webpack_public_path__ + "img/personal-information.75a822eb.svg";